(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .controller('grcObservationWithDetailsController', Controller);

    Controller.$inject = ['$scope', 'grcObservationService'];

    function Controller($scope, grcObservationService) {

        if (!_.isUndefined($scope.boxModel.ObservationID)) {

            grcObservationService.getObservation($scope.boxModel.ObservationID)
                                 .then(function (result) {
                                    $scope.observationDetails = result;
                                 });
       }
    }
})();